import DeleteIcon from "@mui/icons-material/DeleteOutlineOutlined";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Trans } from "react-i18next";
import { Form } from "react-router";

const DeleteCaseDialog = ({
  open,
  onClose,
  deleteAction,
  caseId,
  caseTitle,
}: {
  open: boolean;
  onClose: () => void;
  deleteAction: string;
  caseId: string;
  caseTitle: string;
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Trans
          i18nKey="case.list.deleteDialog.title"
          values={{
            id: caseId,
          }}
        />
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Trans
            i18nKey="case.list.deleteDialog.question"
            values={{
              name: caseTitle,
            }}
          />
        </DialogContentText>
      </DialogContent>
      <Form method="post" action={deleteAction} onSubmit={onClose}>
        <DialogActions>
          <Button
            color="error"
            variant="contained"
            autoFocus
            startIcon={<DeleteIcon />}
            type="submit"
          >
            <Trans i18nKey="case.list.deleteDialog.delete" />
          </Button>
          <Button
            type="button"
            onClick={onClose}
            color="primary"
            variant="outlined"
          >
            <Trans i18nKey="case.list.deleteDialog.cancel" />
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  );
};

export default DeleteCaseDialog;
